import React from "react";

import { Button, Input, Label, UncontrolledTooltip } from "reactstrap";

// emoji picker
import Picker from "emoji-picker-react";
import { Utils } from "helpers/utils";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { UserTypes } from "api";

interface StartButtonsProps {
  onToggle: () => void;
  onEmojiClick: any;
  emojiPicker: any;
  setemojiPicker: any;

  onSelectFiles: (files: Array<any>) => void;
  onClickQuickReply: () => void;
}

const StartButtons = ({ onToggle, onEmojiClick, emojiPicker, setemojiPicker, onSelectFiles, onClickQuickReply }: StartButtonsProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Profile2,
    (p2) => ({
      userType: p2.userType
    })
  );
  const { userType } = useAppSelector(storeData);

  const onSelectF = (e: any) => {
    const files = [...e.target.files];
    if (files) {
      onSelectFiles(files);
      // onToggle();
    }
  };

  const showEmoji = false;
  const deviceOs = Utils.GetDeviceOS();
  // const showAttacIcon = deviceOs == "Windows" || deviceOs == "Android";
  const showAttacIcon = true; // 20260327 because in iphone, mac cannot attached file
  const showCameraIcon = deviceOs != "Windows";
  const showGallaryIcon = deviceOs != "Windows";
  const cameraAccept = deviceOs == "Android" ? "image/*" : "image/*,video/*";
  const showQuickReply = userType === UserTypes.Employee;
  //  const isWindows = deviceOs == "Windows";

  return (
    <div className="chat-input-links me-md-2">


      <div className="links-list-item-ex " id="more-menu" style={{ display: "none" }}>
        <Button
          type="button"
          className="btn btn-link text-decoration-none btn-lg waves-effect"
          onClick={onToggle}
          color="none"
        >
          <i className="bx bx-dots-horizontal-rounded align-middle"></i>
        </Button>
      </div>

      {/* FILE */}
      {showAttacIcon && (
        <div className="links-list-item-ex" id="more-menu" style={{ display: "" }}>
          <Input
            id="attachedfile-input2"
            type="file"
            // accept="image/*"
            className="d-none"
            onChange={(e: any) => onSelectF(e)}
            multiple
          />
          <Label htmlFor="attachedfile-input2" className="label-icon-attach  mx-auto hand " >
            <i className="bx bx-paperclip"></i>
          </Label>
        </div>
      )}

      {/* CAMERA */}
      {showCameraIcon && (
        <div className="links-list-item-ex " id="more-menu" style={{ display: "" }}>
          <Input
            id="attachedfile-camera"
            type="file"
            accept={cameraAccept} capture="environment"
            className="d-none"
            onChange={(e: any) => onSelectF(e)}
            multiple
          />
          <Label htmlFor="attachedfile-camera" className="label-icon-attach  mx-auto hand" >
            <i className="bx bx-camera"></i>
          </Label>
        </div>
      )}

      {/* GALLARY */}
      {showGallaryIcon && (
        <div className="links-list-item-ex " id="more-menu" style={{ display: "" }}>
          <Input
            id="attachedfile-gallary"
            type="file"
            accept="image/*,video/*"
            className="d-none"
            onChange={(e: any) => onSelectF(e)}
            multiple
          />
          <Label htmlFor="attachedfile-gallary" className="label-icon-attach  mx-auto hand">
            <i className="bx bx-image"></i>
          </Label>
        </div>
      )}

      {/* quick reply */}
      {showQuickReply && (
        <div className="links-list-item-ex" id="quick-reply" style={{ display: "" }}>
          {/* <Input
            id="attachedfile-input2"
            type="file"
            // accept="image/*"
            className="d-none"
            onChange={(e: any) => onSelectF(e)}
            multiple
          /> */}
          <Label className="label-icon-quick-reply  mx-auto hand" onClick={onClickQuickReply} >
            <i className="fab fa-rocketchat"></i>
          </Label>
        </div>
      )}





      {/* <UncontrolledTooltip target="more-menu" placement="top">
        More
      </UncontrolledTooltip> */}
      {emojiPicker && <Picker onEmojiClick={onEmojiClick} width={350} height={382} />}
      <div className="links-list-item-ex " id="emoji" style={{ display: "none" }}>
        <Button
          type="button"
          className="btn btn-link text-decoration-none btn-lg waves-effect emoji-btn label-icon-attach-sm"
          id="emoji-btn"
          color="none"
          onClick={() => setemojiPicker(!emojiPicker)}
        >
          <i className="bx bx-smile align-middle" ></i>
        </Button>
      </div>
    </div>
  );
};

export default StartButtons;
